import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  getToken,
  getCurrentLanguage,
} from "../../shared/utils.js/utils";

// Get  Notes Payable
export const getNotesPayable = createAsyncThunk(
  "NotesPayable/getNotesPayable",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.per_page) queryParams.append("per_page", params.per_page);
      if (params.search) queryParams.append("search", params.search);
      const url = `${BASE_URL}/notes-payable${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return { data: response.data, params };
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get notes payable!";
      return rejectWithValue(message);
    }
  },
);

// add Note Payable
export const addNotePayable = createAsyncThunk(
  "NotesPayable/addNotePayable",
  async (payload, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.post(`${BASE_URL}/notes-payable`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      let message =
        error.response?.data?.message || "Failed to add note payable!";
      if (error.response?.data?.errors) {
        message = JSON.stringify(error.response.data.errors);
      }
      return rejectWithValue(message);
    }
  },
);

//get NotePayable details
export const getNotePayableDetails = createAsyncThunk(
  "NotesPayable/getNotePayableDetails",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.get(`${BASE_URL}/notes-payable/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get note payable details!";
      return rejectWithValue(message);
    }
  },
);

// update note payable (PUT)
export const updateNotePayable = createAsyncThunk(
  "NotesPayable/updateNotePayable",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.put(
        `${BASE_URL}/notes-payable/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      let message =
        error.response?.data?.message || "Failed to update note payable!";
      if (error.response?.data?.errors) {
        message = JSON.stringify(error.response.data.errors);
      }
      return rejectWithValue(message);
    }
  },
);

// Pay Note Payable
export const payNotePayable = createAsyncThunk(
  "NotesPayable/payNotePayable",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.post(
        `${BASE_URL}/notes-payable/${id}/pay`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      let message =
        error.response?.data?.message || "Failed to pay note payable!";
      if (error.response?.data?.errors) {
        message = JSON.stringify(error.response.data.errors);
      }
      return rejectWithValue(message);
    }
  },
);

// Cancel Note Payable
export const cancelNotePayable = createAsyncThunk(
  "NotesPayable/cancelNotePayable",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.post(
        `${BASE_URL}/notes-payable/${id}/cancel`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to cancel note payable!";
      return rejectWithValue(message);
    }
  },
);
